
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1612d_16g84_43",
  "spinner-rotator": "awsui_spinner-rotator_1612d_16g84_1",
  "size-x-small": "awsui_size-x-small_1612d_16g84_58",
  "size-normal": "awsui_size-normal_1612d_16g84_65",
  "size-big": "awsui_size-big_1612d_16g84_72",
  "size-large": "awsui_size-large_1612d_16g84_79",
  "variant-normal": "awsui_variant-normal_1612d_16g84_86",
  "variant-disabled": "awsui_variant-disabled_1612d_16g84_89",
  "variant-inverted": "awsui_variant-inverted_1612d_16g84_92",
  "circle": "awsui_circle_1612d_16g84_104",
  "circle-left": "awsui_circle-left_1612d_16g84_132",
  "spinner-line-left": "awsui_spinner-line-left_1612d_16g84_1",
  "circle-right": "awsui_circle-right_1612d_16g84_137",
  "spinner-line-right": "awsui_spinner-line-right_1612d_16g84_1"
};
  